import { Can, hasPermission as sharedHasPermission, isFreeUser as sharedIsFreeUser } from 'zl-shared';

import store from '../../redux/store';
import rules from './rules';

export const hasPermission = (action, data) => {
  const {
    user: { role },
  } = store.getState();

  return sharedHasPermission(action, data, role, rules);
};

export const isFreeUser = () => {
  const {
    user: { role, subscription },
  } = store.getState();
  return sharedIsFreeUser(role, subscription);
};

export default Can(hasPermission);
